import React from "react";

export default function Footer() {
    return (
        <div style={{ fontSize: 12, textAlign: "center", padding: "20px 0px" }}>
            This is a computer generated document. No signature is required.
        </div>
    )
}